import { render, staticRenderFns } from "./AbroadChangguanDetails.vue?vue&type=template&id=1a1cd572&scoped=true"
import script from "./AbroadChangguanDetails.vue?vue&type=script&lang=js"
export * from "./AbroadChangguanDetails.vue?vue&type=script&lang=js"
import style0 from "./AbroadChangguanDetails.vue?vue&type=style&index=0&id=1a1cd572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1cd572",
  null
  
)

export default component.exports